import {Button, Card, Typography} from '@mui/material';
import React, {useState} from 'react';

import {IconIllustration} from 'presentation/components';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {translations} from 'presentation/translations-new';
import {formatText, getOnlyFirstWord} from 'presentation/utils';
import {StyledNotificationsContainer} from '../../../styles';
import {GracePeriodDetails} from './GracePeriodDetails';
import {StyledCardActions, StyledCardContent} from './styles';

const {learnMore} = translations['pt-br'].commons;
const {isInPlanGracePeriod} = translations['pt-br'].privateFlow.home;

export function GracePeriodNotifications() {
	const {
		beneficiary: {nmSocialUsuarioC, nmUsuarioC},
	} = useAccountDataStore(store => store.accountData);
	const [showDetailsState, setShowDetailsState] = useState(false);

	function handleShowDetails() {
		setShowDetailsState(true);
	}

	const formattedDescription = `${getOnlyFirstWord(
		formatText(nmSocialUsuarioC || nmUsuarioC),
	)}, ${isInPlanGracePeriod}`;

	return (
		<StyledNotificationsContainer>
			<Card sx={{boxShadow: 'none'}}>
				<StyledCardContent>
					<Typography variant="body2" color="text.primary">
						{formattedDescription}
					</Typography>
					<IconIllustration variant="primary" size="small" customIconName="pizza-chart" />
				</StyledCardContent>
				{!showDetailsState ? (
					<StyledCardActions>
						<Button onClick={handleShowDetails} variant="outlined" fullWidth>
							{learnMore}
						</Button>
					</StyledCardActions>
				) : null}
			</Card>
			{showDetailsState ? (
				<GracePeriodDetails
					setShowDetails={setShowDetailsState}
					showDetails={showDetailsState}
				/>
			) : null}
		</StyledNotificationsContainer>
	);
}
